import React, { useContext } from 'react'
import PropType from 'prop-types'
import cx from 'classnames'
import { fireGtmEvent } from 'utils/gtm'
import { getMetaQuery } from 'utils/data'
import CtaButton from 'components/cta-button'
import useMaxCTALengthWarning from 'components/hooks/useMaxCTALengthWarning'
import WidgetContext from 'components/widget-context'
import styles from './styles.scss'

const SimpleCta = ({
  url,
  variation,
  customCTA,
  variations,
  utms,
  large,
  nmls,
  onClickHandle,
  metaParams,
  verticals,
  type,
  theme,
  uniqueId,
}) => {
  const widgetContext = useContext(WidgetContext),
    queryString = Object.keys(utms)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`)
      .join('&'),
    metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme),
    href = `${url}?${queryString}${metaQuery}`,
    className = large ? styles.large : styles.small

  useMaxCTALengthWarning({ customCTA, large, uniqueId })

  return (
    <div className={styles.wrapper}>
      <CtaButton
        href={href}
        className={cx(className, {
          [styles.truncated]: customCTA,
        })}
        onClick={onClickHandle(widgetContext)}
        blank
      >
        {customCTA || variations[variation]}
      </CtaButton>
      {nmls && <div className={styles.cred}>Credible Operations, Inc. NMLS # 1681276</div>}
    </div>
  )
}

const onClickHandleDefault = widgetContext => () => {
  fireGtmEvent('ctaClick', widgetContext)
}

SimpleCta.propTypes = {
  url: PropType.string.isRequired,
  variation: PropType.string.isRequired,
  uniqueId: PropType.string,
  customCTA: PropType.string,
  variations: PropType.object,
  utms: PropType.object.isRequired,
  large: PropType.bool,
  nmls: PropType.bool,
  onClickHandle: PropType.func,
  metaParams: PropType.object,
  verticals: PropType.array,
  type: PropType.string,
  theme: PropType.string,
}

SimpleCta.defaultProps = {
  large: false,
  variations: {
    'compare-rates': 'Compare Rates',
    'find-my-rate': 'Find My Rate',
    'learn-more': 'Learn More',
  },
  uniqueId: null,
  customCTA: null,
  nmls: false,
  onClickHandle: onClickHandleDefault,
}

export { SimpleCta, onClickHandleDefault as onClick }

export default SimpleCta
